import { ProjectFiles } from "./ProjectFiles"
import {
  Popconfirm,
  Row,
  Col,
  Tag,
  Input,
} from "antd"
import SubmitPackageSerialNUmber from "./SubmitPackageSerialNumber"
export const renderFileButton = (row, { props, setErrorMessage }) => {
  return (
    <ProjectFiles
      rowData={row}
      mainProps={props}
      setErrorMessage={setErrorMessage}
    />
  )
}

export const renderFloorNumber = row => {
  if (row.floorNumber == 0 && row.unitNumber == 1) return <small>همکف</small>
  if (row.floorNumber == 0 && row.unitNumber > 1)
    return <small>چند واحدی</small>
  return row.floorNumber
}

export const renderExeFullName = (row, props) => {
  return row.executor.fullName
}



export const renderRowNumber = (index, { pageIndex, pageSize }) => {
  return (pageIndex - 1) * pageSize + index + 1
}


export const renderSubmitPackage = (params, { props }) => {
  return <SubmitPackageSerialNUmber rowData={params} mainProps={props} />

}




export const projectColumnsAnt = props =>
  [

    
    {
      title: "شماره /مالک",
      key: "fileNumber",
      render: params => (
        <Row gutter={[8, 4]} justify="start" className="flex-row-reverse">
          <Col span={24}>{params.fileNumber}</Col>
          <Col span={24}>{params.landlordName}</Col>
          <Col span={24}><Tag color="blue">کد پستی: {params.postalCode}</Tag>
          </Col>
        </Row>
      ),
      width: "10rem",
    },
    {
      title: "ثبت شماره سریال",
      key: "fileNumber",
      render: params => (
        <div className="d-flex flex-column gap-2 justify-content-center align-items-right">
          {
            renderSubmitPackage(params, props)}

        </div>
      ),
      width: "20rem",
    },
    // {
    //   title: "وضعیت فایل",
    //   key: "isUploadElectPlan",
    //   render: params => (
    //     <div className="d-flex flex-column gap-2 justify-content-center align-items-center">
    //       <Tag
    //         style={{ width: "4.1rem" }}
    //         color={params.isUploadIdCard ? "green" : "red"}
    //       >
    //         عکس شماره سریال
    //       </Tag>
    //       <Tag
    //         style={{ width: "4.1rem" }}
    //         color={params.isUploadApprovedPostalCode ? "green" : "red"}
    //       >
    //         کدپستی
    //       </Tag>

    //       <Tag
    //         style={{ width: "4.1rem" }}
    //         color={params.isUploadFirstPlan ? "green" : "red"}
    //       >
    //         پلان‌معماری
    //       </Tag>
    //       <Tag
    //         style={{ width: "4.1rem" }}
    //         color={params.isUploadIsoPlan ? "green" : "red"}
    //       >
    //         ایزومتریک
    //       </Tag>
    //     </div>
    //   ),
    //   width: "6rem",
    // },
    //   // Fils
    // {
    //   title: "فایلها",
    //   key: "File",
    //   render: params => (
    //     <div className="d-flex flex-column gap-2 justify-content-center align-items-center">
    //       {renderFileButton(params, props)}
    //     </div>
    //   ),
    //   width: "9rem",
    // },

    {
      title: "آدرس",
      key: "solarRegisterDate",
      render: row => (
        <div className="text-wrap">
          <span>
            {row.address}
          </span>
        </div>
      ),
    },
    {
      title: "واحد/طبقه",
      key: "unitNumber",
      render: params => (
        <div className="d-flex flex-column gap-2 justify-content-center align-items-center">
          <Tag>واحد: {params.unitNumber}</Tag>
          <Tag>طبقه: {renderFloorNumber(params)}</Tag>
        </div>
      ),
      width: "6rem",
    }
  ]
  // .filter(x => !x.hidden)
